import { BOARD_HOURS, BOARD_WIDTH, HOUR_WIDTH } from '../../../shared/lib/schedule';

/**
 * The hour ruler. Each label sits at the left edge of its own column, so it lines up with the
 * gridline the rows draw at the same offset.
 */
export const BoardTimeAxis = () => (
  <div className="relative flex shrink-0" style={{ width: BOARD_WIDTH }}>
    {BOARD_HOURS.slice(0, -1).map((hour) => (
      <div
        key={hour}
        className="shrink-0 border-l border-slate-200 py-3 text-center text-sm font-normal text-zinc-500"
        style={{ width: HOUR_WIDTH }}
      >
        {String(hour).padStart(2, '0')}:00
      </div>
    ))}
  </div>
);
